// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/card.css
// module id = 843
// module chunks = 2